<template>
  <div style="padding-bottom: 10px">
    <div class="row">
      <div class="col-md-2">
        <p>
          Комплектуюющие и материалы <i v-on:click="hide" class="tim-icons icon-minimal-up"></i>
        </p>
      </div>
      <div class="col-md-10">
        <p>
          Добавить
          <i v-on:click="newCall" class="tim-icons icon-chat-33"></i>
        </p>
      </div>
    </div>
    <big-one :content="content" :type = "type" :a-page="false" :hide-pages="true" :page-limits="pageLimits" :tuning="false"
             :new-one="newOne"
             :default-sort="date" :default-sort-direction="false"
             @resetNew="newOne = null"></big-one>
  </div>
</template>
<script>

import {
  BaseInput,
  Card
} from "@/components/index";

import {sorter} from "@/services/utils";
import {authHeader} from "@/services/auth-header";
import {userService} from "@/services/user.service";

const productCategory = {header: "Категория номенклатуры", name: "category.name", show: true};
const product = {header: "Номенклатура", name: "product.name", show: true, sort: true};
const price = {header: "Стоимость", name: "price", show: true};
const quantity = {header: "Количество", name: "quantity", show: true};
const deleteOption = {header: "Удалить", action:true, toDelete: true, show: true};

export default{
  components:{
    Card,
    BaseInput
  },
  props:{
    item: {}
  },
  data() {
    return {
      content: [productCategory, product, price, quantity, deleteOption],
      type: "item",
      pageLimits: {kit: this.item.id},
      newOne: null
    };
  },
  methods: {
    hide() {
      this.$emit('hide');
    },
    newCall() {
      let object = {kit: this.item, id: 0};
      this.newOne = ({object: object, id: object.id, view: 'edit'});
    }
  }
}
</script>
<style>
</style>
